// extracted by mini-css-extract-plugin
export default {"link":"NavbarLink_link__vSt8a"};